import { PropsWithChildren, ReactNode } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { translate } from '@/domain/utils/translate';
import Icon from '@/ui/assets/Icon';

type PropsInputList = {
  title?: string;
  text?: string | ReactNode;
  iconName?: string;
  onClick?: (params: any) => ReactNode | void;
  className?: string;
};

const InputList = ({ title = '', text = '', iconName = '', onClick, className = '' }: PropsWithChildren<PropsInputList>): JSX.Element => {

  const ICON_TEXT: string = translate('general.more_icon_text');

  const renderTextContent = () => (
    <>
      <Col xs={3} className='text-secondary-1 p-0 my-3'>
        <span className='paragraph '>{title}</span>
      </Col>
      <Col xs={7} className='my-3'>
        <small className={`paragraph  ${iconName === '' ? 'text-tertiary-1 fw-light' : ''} ${className}`}>{text}</small>
      </Col>
    </>
  );

  const renderEmptyContent = () => (
    <>
      <Col xs={3} className='text-secondary-1 p-0 my-3'>
        <span className='paragraph'>{title}</span>
      </Col>
      <Col xs={9} className='text-end text-primary-1 my-3'>
        <span className='p-regular-medium px-1'>{ICON_TEXT}</span>
      </Col>
    </>
  );

  const renderIcon = () => (
    <Col xs={2} className='text-end text-tertiary-5 my-3 '>
      <Icon name={iconName} />
    </Col>
  );

  return (
    <Container fluid id='input-list' className='p-0'>
      <Row className='g-0 p-0'>
        <Col xs={12} className='border-bottom pt-3 pb-2 cursor-hand d-flex text-break g-0'>
          <Col onClick={onClick}>
            <Row className='p-0 m-0'>
              {text ? renderTextContent() : renderEmptyContent()}
              {text && renderIcon()}
            </Row>
          </Col>
        </Col>
      </Row>
    </Container>
  );
};

export default InputList;
